import React, { FunctionComponent, ReactNode } from 'react';
import { CheckCircleOutlined, DisconnectOutlined, MailOutlined } from '@ant-design/icons';
import { AuthHeading } from './AuthCard';
import styles from './AuthResult.module.scss';

type ResultTone = 'sent' | 'done' | 'failed';

const ICONS: Record<ResultTone, ReactNode> = {
  sent: <MailOutlined aria-hidden />,
  done: <CheckCircleOutlined aria-hidden />,
  failed: <DisconnectOutlined aria-hidden />,
};

interface AuthResultProps {
  tone: ResultTone;
  title: ReactNode;
  text: ReactNode;
  /** Przyciski na pełną szerokość karty, jeden pod drugim. */
  actions?: ReactNode;
  note?: ReactNode;
}

/**
 * Wynik w miejscu formularza (wysłano link, hasło zmienione, link nieaktualny): ikona w kółku
 * z triady stanu, tytuł z fokusem, opis i akcje. Zastępuje antd `Result` ze starych ekranów.
 */
const AuthResult: FunctionComponent<AuthResultProps> = ({ tone, title, text, actions, note }) => (
  // Bez roli live: tytuł dostaje fokus i czytnik go ogłasza, a odliczanie w treści nie gada co sekundę.
  <div className={styles.result}>
    <span className={`${styles.icon} ${styles[tone]}`}>{ICONS[tone]}</span>
    <AuthHeading title={title} lead={text} focusOnMount />
    {actions && <div className={styles.actions}>{actions}</div>}
    {note && <p className={styles.note}>{note}</p>}
  </div>
);

export default AuthResult;
